/**
 * COMMERCE-WORKSPACE-FRAMEWORK-000001 — clipboard bulk helpers (honest, local-only).
 */

export async function copyLinesToClipboard(
  lines: string[],
  emptyMessage: string,
): Promise<string> {
  if (lines.length === 0) return emptyMessage;
  try {
    await navigator.clipboard.writeText(lines.join('\n'));
    return `Copied ${lines.length}`;
  } catch {
    return 'Clipboard unavailable';
  }
}
